<template>
    <label class="def-textarea">
        <span class="def-textarea__label">{{ label }}</span>
        <textarea
            class="def-textarea__input"
            :name="name"
            cols="30"
            rows="10"
            :placeholder="placeholder"
        />
    </label>
</template>

<script>
export default {
    name: 'DefTextarea',
    props: ['result', 'placeholder', 'label', 'name'],
}
</script>

<style lang="scss" scoped>
.def-textarea{
    &__input{
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        padding: 14px 22px;
        width: 100%;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        &::placeholder{
            color: #979797;
        }
        &:focus-visible{
            outline: none;
        }
    }
    &__label{
        display: inline-block;
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        margin-bottom: 9px;
    }
}
</style>